import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components.
import H3 from '../../components/H3';
import Result from './Result';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Results = ({ className, title, data }) =>
  <div className={classNames('Results', className)}>
    <H3 className="Results__H3">
      {title}
    </H3>
    {data.map(({ uid, label, output, suffix, format }, i) =>
      <Result
        key={uid}
        className={`Result--${i}`}
        label={label}
        output={output}
        suffix={suffix}
        format={format}
      />,
    )}
  </div>;

Results.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string,
      label: PropTypes.node.isRequired,
      output: PropTypes.node.isRequired,
      suffix: PropTypes.node,
      format: PropTypes.bool,
    }),
  ).isRequired,
};

Results.defaultProps = {
  className: null,
};

export default Results;



// WEBPACK FOOTER //
// ./src/components/Results/index.js